@if (debugMode.isDebugMode()) {
<mat-chip class="small" disableRipple>
  {{ data().tool_name }} · {{ status() }}
</mat-chip>
}
